module.exports = __webpack_public_path__ + "static/media/raindrops.6af9a620.svg";